import { Box, Typography, Button, Link } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";

const AIFlashcards = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      m="40px auto"
      p="30px"
      maxWidth="800px"
      border="2px solid #E5E8E8"
      borderRadius="12px"
      boxShadow="0px 4px 10px rgba(0, 0, 0, 0.1)"
      backgroundColor={colors.primary[900]}
    >
      {/* Back Button */}
      <Button
        startIcon={<ArrowBack sx={{ transition: "transform 0.2s ease" }} />}
        onClick={() => navigate(-1)}
        sx={{
          color: "colors.primary[200]",
          backgroundColor: "transparent",
          fontWeight: "bold",
          "&:hover .MuiButton-startIcon": {
            transform: "translateX(-7px)",
          },
        }}
      >
        Back
      </Button>
      {/* Project Title */}
      <Typography
        variant="h3"
        fontWeight="bold"
        color={colors.primary[200]}
        my={2}
      >
        <Link
          href="https://flipme.vercel.app/"
          target="_blank"
          underline="none"
          color="inherit"
          sx={{
            textDecoration: "none",
            px: 1,
            borderRadius: 1,
            transition: "background-color 0.3s",
            "&:hover": {
              backgroundColor: "grey.300",
              cursor: "pointer",
            },
          }}
        >
          AI Flashcards
        </Link>
      </Typography>
      {/* Project Description */}
      <Typography variant="h5" color={colors.primary[200]} mb={3}>
        A study tool that generates custom flashcards based on user inputted
        topics.
      </Typography>
      {/* Demo Section */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Demo:
      </Typography>
      <iframe
        src="https://www.youtube.com/embed/agC1MDCDUaA?autoplay=0&mute=1&loop=1"
        title="video"
        allow="autoplay"
        frameborder="0"
        style={{
          width: "100%",
          aspectRatio: "16 / 9",
          height: "auto",
        }}
      ></iframe>
      {/* Technical Challenges */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Technical Challenges:
      </Typography>
      <Box component="ul" sx={{ pl: 3, color: colors.primary[200], mb: 3 }}>
        <li>
          Saving flashcard set data and retrieving previous sets for each user.
        </li>
        <li>Building a intuitive, logical, efficient user interface</li>
      </Box>
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Features:
      </Typography>
      <Box component="ul" sx={{ pl: 3, color: colors.primary[200], mb: 3 }}>
        <li>
          Saving flashcard set data and retrieving previous sets for each user.
        </li>
        <li>Building a intuitive, logical, efficient user interface</li>
      </Box>
      {/* Technologies used */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Technologies used:
      </Typography>{" "}
      <Box
        display={"flex"}
        flexWrap="wrap"
        sx={{ pl: 3, color: colors.primary[200], mb: 3 }}
      >
        {[
          "Next.js",
          "React",
          "MaterialUI",
          "TypeScript",
          "Node.js",
          "Express",
          "Firebase",
          "Clerk",
        ].map((tech) => (
          <Box
            key={tech}
            component=""
            sx={{
              px: 1.5,
              py: 0.5,
              m: 0.5,
              border: `1px solid ${colors.primary[200]}`,
              borderRadius: "8px",
              color: colors.primary[200],
              fontSize: "0.875rem",
              backgroundColor: "rgba(255, 255, 255, 0.05)", // Subtle background
              "&:hover": {
                backgroundColor: colors.primary[200],
                color: "#000", // Contrast color on hover
                cursor: "default",
              },
            }}
          >
            {tech}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AIFlashcards;
